import React from 'react';
import TransMessagesContainer from './TransMessages/TransMessagesContainer';

const TransMessages = () => {
    return <TransMessagesContainer />;
};

export default TransMessages;
